import {Model, ModelMixin} from '../../common/model.class';
import {Address} from '../../common/values/address.class';
import {InstitutionContact} from '../common/values/institution-contact.class';
import {AttendanceDuration} from '../common/values/attendance-duration.class';
import {ProgramInfo} from '../common/values/program-info.class';
import moment = require('moment');
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class Residency extends ModelMixin() implements Model<Residency> {

    TYPE = Residency;

    institution?: string;
    contact: InstitutionContact = new InstitutionContact();
    address: Address = new Address();
    typeOrSpecialty?: string;
    graduationDate?: Moment;
    program: ProgramInfo = new ProgramInfo();
    attendance: AttendanceDuration = new AttendanceDuration();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.graduationDate) jsonData.graduationDate = moment(jsonData.graduationDate);
        if (jsonData.attendance) jsonData.attendance = new AttendanceDuration(jsonData.attendance);
        if (jsonData.program) jsonData.program = new ProgramInfo(jsonData.program);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/residency/residency.model.ts